/* Bong Trendz wishlist — device-local (localStorage "btWishlist").
   Owns: heart buttons ([data-bt-wishlist]), header count badges
   ([data-bt-wishlist-count]). The wishlist page renders itself via
   window.BTWishlist (sections/bt-wishlist-page.liquid). */
(function () {
  var KEY = 'btWishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    fire();
  }

  function has(handle) {
    return read().some(function (x) { return x.h === handle; });
  }

  function add(handle) {
    if (!handle || has(handle)) return;
    var list = read();
    list.unshift({ h: handle, t: Date.now() });
    write(list);
  }

  function remove(handle) {
    write(read().filter(function (x) { return x.h !== handle; }));
  }

  function toggle(handle) {
    has(handle) ? remove(handle) : add(handle);
    return has(handle);
  }

  function fire() {
    document.dispatchEvent(new CustomEvent('bt:wishlist:change', { detail: { count: read().length } }));
  }

  window.BTWishlist = {
    list: read,
    handles: function () { return read().map(function (x) { return x.h; }); },
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
  };

  function syncButtons(root) {
    (root || document).querySelectorAll('[data-bt-wishlist]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-bt-wishlist'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-bt-wishlist-label]');
      if (label) label.textContent = on ? btn.dataset.labelRemove : btn.dataset.labelAdd;
    });
  }

  function syncBadges() {
    var n = read().length;
    document.querySelectorAll('[data-bt-wishlist-count]').forEach(function (el) {
      el.textContent = n > 9 ? '9+' : n;
      el.hidden = n === 0;
    });
  }

  function syncAll() {
    syncButtons();
    syncBadges();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bt-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-bt-wishlist'));
  });

  document.addEventListener('bt:wishlist:change', syncAll);
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) syncAll();
  });
  document.addEventListener('shopify:section:load', syncAll);

  // facets AJAX swaps the product grid — re-sync hearts when it changes
  function observeGrid() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    new MutationObserver(function () { syncButtons(grid); }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll();
      observeGrid();
    });
  } else {
    syncAll();
    observeGrid();
  }
})();
